import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/auth/me').then(r => { setUser(r.data.user); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    await api.post('/auth/logout');
    setUser(null);
    // Clear cart from localStorage on logout so prices/items don't persist for next user
    localStorage.removeItem('en_cart');
  };

  const register = async (data) => {
    const r = await api.post('/auth/register', data);
    return r.data;
  };

  const isAdmin = user?.role === 'admin';
  const isBuyer = user?.role === 'buyer' || user?.role === 'admin';

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, register, isAdmin, isBuyer }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
